import React, { Fragment } from 'react';
import { TimeJumpButton } from './TimeJumpButton';
import { getPrimeTimePosition, isTvDayTodayCET, livePositionOfToday } from './tv-guide-types';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const TimeJumpButtons = ({
  scrollPosition,
  scrollRef,
  date,
  pixelsPerMinute,
  left,
  top,
  isListMode = false
}) => {
  const isToday = isTvDayTodayCET(date);
  const livePosition = livePositionOfToday(pixelsPerMinute, left);
  const primeTimePosition = getPrimeTimePosition(pixelsPerMinute, left);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(TimeJumpButton, {
      timeJumpType: 'primeTime',
      left: left,
      top: top,
      timePosition: primeTimePosition,
      scrollPosition: scrollPosition,
      scrollRef: scrollRef,
      isListMode: isListMode
    }), isToday && /*#__PURE__*/_jsx(TimeJumpButton, {
      timeJumpType: 'live',
      left: left,
      top: top,
      timePosition: livePosition,
      scrollPosition: scrollPosition,
      scrollRef: scrollRef,
      isListMode: isListMode
    })]
  });
};